package com.loyola.acessoescola.services.quintadb

enum class ErrorMessages(val message: String) {
    UNKNOWN("Um erro desconhecido está impedindo a atualização dos dados"),
    EXPIRED_TOKEN("Autenticação expirada, faça login novamente para continuar")
}